import i18n from '@/i18n';
const Layout = () => import('@/layouts/main.vue');
const MarketplaceServices = () => import('./views/Index.vue');

export default [
  {
    path: '/marketplace-services',
    component: Layout,
    meta: { authRequired: true, header: true, permission: 'superadmin|marketplaceadmin' },
    children: [
      {
        path: '',
        name: 'MarketplaceServices',
        component: MarketplaceServices,
        meta: { title: i18n.global.t('marketplace.services') },
      },
    ],
  },
];
